var _ = {
	startLoading() {
		var loadingbar = document.createElement("div")
		loadingbar.classList.add("loadingbar")
		document.body.appendChild(loadingbar)
	},
	stopLoading() {
		var loadingbar = document.querySelector(".loadingbar")
		document.body.removeChild(loadingbar)
	}
}
export default _
